import PropTypes from 'prop-types'
import { Checkbox, Form, theme } from 'antd'
import { useIntl } from 'react-intl'

const InlineCheckbox = ({
  className = '',
  onChange = () => {},
  label,
  legend,
  name,
  isRequired = false,
  value = false,
  disabled = false,
  wrapperClass = '',
  errorHelp = false,
  errorMsg = '',
}) => {
  const { token } = theme.useToken()
  const intl = useIntl()

  return (
    <>
      <fieldset className={wrapperClass}>
        {legend && (
          <legend>
            {isRequired && <span style={{ color: token.colorError }}>* </span>}
            {legend}
          </legend>
        )}
        <Form.Item
          name={name}
          valuePropName="checked"
          className='inline-checkbox-form-item'
          rules={
            isRequired
              ? [
                  {
                    validator: (_, checked) => {
                      if (checked) {
                        return Promise.resolve()
                      }
                      return Promise.reject(new Error(intl.formatMessage({id: 'validation.fieldRequired'}, {label: label})))
                    },
                  },
                ]
              : undefined
          }
          {...(errorHelp === false ? { help: null } : {})}
          validateStatus={errorHelp ? 'error' : undefined}
        >
          <Checkbox
            data-testid={name}
            className={className}
            checked={value}
            disabled={disabled}
            onChange={(e) => {
              onChange(e.target.checked)
            }}
          >
            {label}
          </Checkbox>
        </Form.Item>
      </fieldset>
    </>
  )
}

InlineCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]),
  onChange: PropTypes.func,
  className: PropTypes.string,
  legend: PropTypes.string,
  isRequired: PropTypes.bool,
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  wrapperClass: PropTypes.string,
  errorHelp: PropTypes.bool,
  errorMsg: PropTypes.string,
}

export default InlineCheckbox
